import './SourceView.scss';

import SourceView from './SourceView';

export default SourceView;
